const PREFIX = "CUSTOM_REPORT_"

export const SET_CURRENT_SELECTED_MENU = PREFIX + 'SET_CURRENT_SELECTED_MENU';

export const SET_CURRENT_TAGS = PREFIX + "SET_CURRENT_TAGS";

export const SET_CUSTOM_WORKBOOKS = PREFIX + "SET_CUSTOM_WORKBOOKS";

export const SET_CUSTOM_PROJECTS = PREFIX + "SET_CUSTOM_PROJECTS";

export const SET_CUSTOM_WORKBOOKS_REQUEST = PREFIX + "SET_CUSTOM_WORKBOOKS_REQUEST";

export const SET_CUSTOM_PROJECTS_REQUEST = PREFIX + "SET_CUSTOM_PROJECTS_REQUEST";

export const SET_DATA = PREFIX + "SET_DATA";
export const FETCH_ADHOC_REPORTS_REQUEST = PREFIX + "FETCH_ADHOC_REPORTS_REQUEST";
export const FETCH_ADHOC_REPORTS_SUCCESS = PREFIX + "FETCH_ADHOC_REPORTS_SUCCESS";

export const FETCH_ADHOC_REPORTS_FAILURE = PREFIX + "FETCH_ADHOC_REPORTS_FAILURE";